export default __webpack_public_path__ + "static/media/behance.fef008e6.PNG";